import { apiCache } from '../cache';
import { homeService } from './homeService';
import { authService } from './authService';
import { cartService } from './cartService';
import { countryService } from './countryService';

export const cacheService = {
  // Clear all cache
  clearAll: () => {
    apiCache.clear();
  },
  
  // Clear user-specific cache
  clearUserCache: () => {
    apiCache.clearUserCache();
  },
  
  // Clear country-related cache
  clearCountryCache: () => {
    apiCache.clearCountryCache();
  },
  
  // Clear cache by pattern
  clearByPattern: (pattern: string) => {
    apiCache.clearByPattern(pattern);
  },
  
  // Force refresh specific data
  refresh: {
    homeData: () => homeService.getHomeData(true),
    userData: () => authService.getCurrentUser(true),
    authStatus: () => authService.checkStatus(true),
    cartData: () => cartService.getCart(true),
    countries: () => countryService.getCountries(true),
    currencies: () => countryService.getCurrencies(true),
    currentCountry: () => countryService.getCurrentCountry(true),
  }
};

